var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-5",attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"pie","width":"100%","options":_vm.chartOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }